import CircularProgress from '@mui/material/CircularProgress';

export const LoadingScreen = () => {
    return (
        <CircularProgress />
    );
  }
